export default __webpack_public_path__ + "static/media/rovers-page.9ab695ec.png";